import { ReactNode } from 'react';
import { ColumnTooltip } from './ColumnTooltip';
import type { ListingUomFields } from '@/lib/uom';

interface Props {
  listing: ListingUomFields | null | undefined;
  currencySymbol?: string;
  children: ReactNode;
  className?: string;
}

/**
 * Backwards-compatible price tooltip. New code should prefer
 * <ColumnTooltip column="price" ... /> directly.
 */
export function PriceWithTooltip({ listing, currencySymbol = '', children, className }: Props) {
  return (
    <ColumnTooltip column="price" listing={listing} currencySymbol={currencySymbol} className={className}>
      {children}
    </ColumnTooltip>
  );
}
